import React, {Component} from "react";
import {ControlPanelService} from "../../../service/controlPanel/ControlPanelService";
import DetailLoan from "./DetailLoanView";
import {CONTROL_PANEL_ROUTE} from "../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";

export default class DetailLoanContainer extends Component {
    constructor(props) {
        super(props);

        this.controlPanelService = new ControlPanelService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.handleRejectButton = this.handleRejectButton.bind(this);
        this.getSettlementStatus = this.getSettlementStatus.bind(this);


        this.state = {
            isLoading: true,
            loanId: this.props.location.state.folio,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            settlementStatusList: [],
            isAutomaticInstructions: false,
        };

        this.getSettlementStatus();

        this.loanData = React.createRef();
    };

    async componentDidMount() {
        await this.loanData.current.getLoan();
        await this.loanData.current.getRestrictionsLoan(this.state.loanId);
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
        });
    }

    getSettlementStatus() {
        this.controlPanelService.getSettlementStatus(this.state.loanId)
            .then(response => {
                let isAutomatic = false;
                if (localStorage.getItem('institution') === 'Interno') {
                    response.map((item) => {
                        if ((item.ptm !== '' && !item.ptm.includes('N-')) ||
                            (item.ptt !== '' && !item.ptt.includes('N-')) ||
                            (item.fid !== '' && !item.fid.includes('N-'))) {
                            isAutomatic = true;
                        }
                        return '';
                    });
                }

                this.setState({
                    settlementStatusList: response,
                    isAutomaticInstructions: isAutomatic
                });
                this.loading(false);
            });
    }

    handleRejectButton() {
        this.loading(true);
        this.controlPanelService.setFlowSettlement(this.state.loanId)
            .then(response => {
                if (response.message !== "") {
                    let message = {
                        severity: 'success',
                        summary: 'Éxito',
                        detail: response.message,
                    };

                    this.props.history.push({
                        pathname: CONTROL_PANEL_ROUTE,
                        message: message,
                    });
                }
            });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <DetailLoan
            isLoading={this.state.isLoading}
            messagesGrowl={messagesGrowl}
            loading={this.loading}
            handleReturnButton={this.handleReturnButton}
            loanId={this.state.loanId}
            flowId={this.state.flowId}
            selectedLoan={this.state.selectedLoan}
            settlementStatusList={this.state.settlementStatusList}
            isAutomaticInstructions={this.state.isAutomaticInstructions}
            handleRejectButton={this.handleRejectButton}
            loanData={this.loanData}
        />

    }
};